import { useProductReportControllerGetProductCardSummary } from "@/api/types/main";
import { CardOrdersWeeksChart } from "@/components/charts/card.orders.weeks.chart";
import { CardPlanRadialChart } from "@/components/charts/card.plan.radial.chart";
import { CardPlanProgress } from "@/components/custom-ui/card.plan.progress";
import { LoadingSpinner } from "@/components/custom-ui/loading.spinner";
import { ProductDetail } from "@/components/custom-ui/product.detail";
import { ProductImagesCarouselCard } from "@/components/custom-ui/product.images.carousel.card";
import { StockDetail } from "@/components/custom-ui/stock.detail";
import { useCommersCardProps } from "@/hooks/useCommersCardProps";
import { TableIds } from "@/store/tables";

export const CommersCardShared = () => {
  const { productId } = useCommersCardProps({
    TableId: TableIds.Commers_SummaryCard,
  });
  const { data, isLoading, isError, error } =
    useProductReportControllerGetProductCardSummary(productId);

  if (isError) return <div>{error?.message}</div>;
  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      {data && (
        <div className="h-full min-h-0 flex gap-3">
          <div className="basis-1/5 flex-shrink-0 overflow-auto">
            <ProductDetail detail={data} />
          </div>
          <div className="basis-2/5 flex-grow flex flex-col gap-3">
            <div className="flex-none">
              <CardPlanProgress
                actualOrdersAmount={data.actualOrdersAmount}
                plannedOrdersAmount={data.plannedOrdersAmount}
              />
            </div>
            <div className="flex-1">
              <CardPlanRadialChart
                actualProfit={data.actualNetProfitAmount}
                actualOrders={data.actualOrdersAmount}
                actualRevenue={data.actualRevenueAmount}
                plannedProfit={data.plannedNetProfitAmount}
                plannedOrders={data.plannedOrdersAmount}
                plannedRevenue={data.plannedRevenueAmount}
              />
            </div>
            <div className="flex-1">
              <CardOrdersWeeksChart orders={data.orders} />
            </div>
          </div>
          <div className="basis-2/6 flex-shrink-0 flex flex-col gap-3 h-full">
            <div className="flex-1">
              <StockDetail detail={data} />
            </div>
            <div className="flex-none">
              <ProductImagesCarouselCard images={data.additionalImages} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
